import type { BillingStripeNotificationModalProps } from "@v2/types/modalTypes";

import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import { Modal } from "@replohq/lattice/components/modal/Modal";

export const BillingStripeNotificationModal: React.FC<
  BillingStripeNotificationModalProps & {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }
> = ({ buttonText, onConfirm, open, onOpenChange }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const onClick = () => {
    setIsLoading(true);
    onConfirm();
  };

  return (
    <Modal
      open={open}
      title="Welcome to a new billing portal"
      onOpenChange={onOpenChange}
      footer={
        <Button
          variant="primary"
          size="base"
          onClick={onClick}
          loading={isLoading}
        >
          {buttonText}
        </Button>
      }
    >
      <div className="flex flex-col gap-4">
        To enhance your Replo experience, we've transitioned to a new billing
        portal that offers:
        <ul className="list-disc space-y-2 pl-5">
          <li>
            <span className="font-bold">Enhanced security</span> - Payment
            information is safer
          </li>
          <li>
            <span className="font-bold">Full control</span> - Upgrade or
            downgrade on your own
          </li>
          <li>
            <span className="font-bold">Clear visibility</span> - Understand
            exactly how and when you are billed
          </li>
          <li>
            <span className="font-bold">Direct support</span> - Work directly
            with the Replo team for any billing issues
          </li>
        </ul>
        You'll need to enter your payment information again in the new portal.
        Your current plan billed through Shopify will be discontinued and a
        prorated refund will be issued.
      </div>
    </Modal>
  );
};
